import { observer } from 'mobx-react-lite';

import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import type { CartItem } from '~/stores/CartStore';

import styles from './DeliveryDifferenceProduct.module.scss';

const DeliveryDifferenceProduct = ({ cartItem }: { cartItem: CartItem }) => {
  return (
    <div className={styles.root}>
      <div className={styles.preview}>
        <span className={styles.count}>x{cartItem.count}</span>
        <CloudflareResponseImage
          src={cartItem.previewImageThumb}
          srcParams={{ width: 72, height: 72 }}
          srcSetParams={defaultSrcSetParams}
          alt={cartItem.name}
          className={styles.itemHeaderImage}
          loading="lazy"
        />
      </div>
      <div className={styles.title}>{cartItem.name}</div>
    </div>
  );
};

export default observer(DeliveryDifferenceProduct);
